import { useState, useEffect } from "react";
import { templeApi } from "../api/templeApi";

export const useServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Function to get a single service by ID
  const getServiceById = (serviceId) => {
    return services.find((service) => service.id === serviceId);
  };

  // Function to get a single service by slug
  const getServiceBySlug = (slug) => {
    return services.find(service => service.slug === slug);
  };

  const fetchServices = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await templeApi.getServices();

      if (response.data.success) {
        const transformedServices = response.data.data.articles.map(
          (article) => ({
            id: String(article.aid),
            // ADD: Generate slug from article title
            slug: article.article_title
              .toLowerCase()
              .replace(/[^a-z0-9 -]/g, '') // Remove invalid chars
              .replace(/\s+/g, '-') // Replace spaces with -
              .replace(/-+/g, '-') // Replace multiple - with single -
              .trim(),
            image: article.assets?.[0]?.asset_value || "",
            title: article.article_title,
            description: article.article_shortdesc,
            longDescription: article.article_longdesc || "",
            // Add fields needed for ServiceDetails page
            mainHeading: article.article_title,
            description1:
              article.article_longdesc ||
              "Detailed information about this service will be available soon.",
            // description2:
            //   "Join us for this spiritual service and experience divine blessings.",
            // scheduleTitle: "Service Details & Information",
            // Add breadcrumb for Banner component
            breadcrumb: {
              home: "Home",
              current: article.article_title,
            },
            pageTitle: article.article_title,
          })
        );

        setServices(transformedServices);
      } else {
        throw new Error("Failed to fetch services data");
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  return {
    services,
    loading,
    error,
    refetch: fetchServices,
    getServiceById,
    getServiceBySlug, // ADD: Export getServiceBySlug function
  };
};